import CustomerDataProvider, {
  useCustomerData,
} from '@cinch-labs/customer-data-segment'
import { Env, readFromEnv } from '@cinch-nx/environments'
import cx from 'classnames'
import { useEffect } from 'react'

import BlackFridayBanner from './black-friday'
import DepositContributionBanner from './deposit-contribution/deposit-contribution'
import InfoBanner from './info-banner'
import { default as SalePromoBanner } from './sale'
import styles from './shared-ui-promo-banner.module.css'
import SpringSalePromoBanner from './spring-sale/spring-sale-promo-banner'
import WinterSale from './winter-sale'
import { default as XmasPromoBanner } from './xmas'
import NewCarsPromoBanner from './new-cars'

export type BannerName =
  | 'sale'
  | 'xmas'
  | 'info'
  | 'blackFriday'
  | 'winter-sale'
  | 'deposit-contribution'
  | 'spring-sale'
  | 'new-cars'

export function SharedPromoBanner() {
  return (
    <CustomerDataProvider>
      <PromoBanner />
    </CustomerDataProvider>
  )
}

function getActiveBannerName() {
  const defaultBanner: BannerName = 'sale'

  try {
    const activeBanner = readFromEnv(Env.promoBannerName)
    if (!activeBanner) {
      throw new Error('No promotional banner set in environment variables')
    }
    return activeBanner as BannerName
  } catch {
    return defaultBanner
  }
}

function PromoBanner() {
  const activeBanner = getActiveBannerName()

  const { trackEvent } = useCustomerData()

  useEffect(() => {
    trackEvent({
      type: 'track',
      eventName: 'Promotion Viewed',
      data: {
        name: activeBanner,
        position: 'top banner',
      },
    })
  }, [])

  const ComponentMap = new Map<BannerName, JSX.Element>([
    ['sale', <SalePromoBanner />],
    ['xmas', <XmasPromoBanner />],
    ['info', <InfoBanner />],
    ['winter-sale', <WinterSale />],
    ['blackFriday', <BlackFridayBanner />],
    ['deposit-contribution', <DepositContributionBanner />],
    ['spring-sale', <SpringSalePromoBanner />],
  ])

  const Child = ComponentMap.get(activeBanner)

  if (activeBanner === 'new-cars') {
    return <NewCarsPromoBanner />
  }

  if (!Child) return null

  return (
    <div
      className={cx(styles.container, {
        [styles.depositContributionContainer]:
          activeBanner === 'deposit-contribution',
        [styles.containerInfo]:
          activeBanner === 'info' || activeBanner === 'spring-sale',
      })}
    >
      {Child}
    </div>
  )
}
